import styled from 'styled-components';
import { pallette } from '../../config/pallette';

export const Menu = styled.div`
  width: 350px;
  background-color: ${pallette.lightGray};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const MenuFooter = styled.footer`
  width: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  padding: 25px 0;
`;

export const MenuLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 25px 0;
`;

export const LinkButton = styled.a`
  background-color: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;

export const LinkText = styled.span`
  border-bottom: 1px solid ${pallette.text};
  color: ${pallette.text};
  font-size: 16px;
  margin-right: 10px;
`;

export const LogOutButton = styled.button`
  background-color: ${pallette.main};
  color: ${pallette.white};
  padding: 10px 0;
  margin-top: 10px;
  border: none;
  cursor: pointer;
  font-weight: bold;
`;

export const ChatHistoryContainer = styled.div`
  width: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 25px 0;
  height: 100%;
  overflow-y: auto;
`;

export const ChatHistoryTitle = styled.p`
  font-weight: bold;
  font-size: 16px;
`;

export const ChatHistoryItemButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  cursor: pointer;
  border: none;
  padding: 10px 15px;
  background-color: ${({ selected }) =>
    selected ? pallette.highlight : 'transparent'};
`;

export const ChatHistoryItem = styled.span`
  font-size: 16px;
`;

export const NewChatButton = styled.button`
  border: none;
  padding: 15px 0;
  margin: 30px 0 60px 0;
  border-bottom: 3px solid ${pallette.main};
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${pallette.text};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const NewChatText = styled.span`
  font-weight: bold;
  font-size: 16px;
  margin-right: 10px;
`;
